import Component from '@glimmer/component';

interface UiSwitchButtonSignature {
  Element: HTMLElement;
  Args: {
    Named: {
      tagName?: string;
      guid: string;
      isOn: boolean;
      labelGuid: string;
      onClick: () => void;
      onKeyUp: () => void;
    };
  };
}

export default class UiSwitchButtonComponent extends Component<UiSwitchButtonSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Switch::Button': typeof UiSwitchButtonComponent;
    'ui/switch/button': typeof UiSwitchButtonComponent;
  }
}
